const TOKEN_KEY = 'dhikr_token'
const REFRESH_TOKEN_KEY = 'dhikr_refresh_token'
const EXPIRES_AT_KEY = 'dhikr_expires_at'
const CSRF_TOKEN_KEY = 'dhikr_csrf_token'
const USER_KEY = 'dhikr_user'

/** Buffer before expiry to proactively refresh (ms). */
const TOKEN_EXPIRY_BUFFER_MS = 60_000

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function setRefreshToken(refreshToken: string): void {
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
}

export function removeRefreshToken(): void {
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}

export function getTokenExpiresAt(): string | null {
  return localStorage.getItem(EXPIRES_AT_KEY)
}

export function setTokenExpiresAt(expiresAt: string): void {
  localStorage.setItem(EXPIRES_AT_KEY, expiresAt)
}

export function removeTokenExpiresAt(): void {
  localStorage.removeItem(EXPIRES_AT_KEY)
}

export function getCsrfToken(): string | null {
  return localStorage.getItem(CSRF_TOKEN_KEY)
}

export function setCsrfToken(csrfToken: string): void {
  localStorage.setItem(CSRF_TOKEN_KEY, csrfToken)
}

export function removeCsrfToken(): void {
  localStorage.removeItem(CSRF_TOKEN_KEY)
}

export function getStoredUser(): { id: string; name: string; email: string; preferredLanguage: string; roles: string[] } | null {
  try {
    const raw = localStorage.getItem(USER_KEY)
    if (!raw) return null
    const u = JSON.parse(raw) as { id: string; name: string; email: string; preferredLanguage: string; roles?: string[] }
    if (!u?.id) return null
    return { ...u, roles: u.roles || [] }
  } catch {
    return null
  }
}

export function setStoredUser(user: { id: string; name: string; email: string; preferredLanguage: string; roles?: string[] }): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function removeStoredUser(): void {
  localStorage.removeItem(USER_KEY)
}

export function isTokenExpired(expiresAt: string | null | undefined): boolean {
  if (!expiresAt) return false
  const expiryTime = new Date(expiresAt).getTime()
  if (Number.isNaN(expiryTime)) return false
  return Date.now() >= expiryTime - TOKEN_EXPIRY_BUFFER_MS
}

export function hasRefreshCredentials(): boolean {
  return !!(getCsrfToken() || getRefreshToken())
}

export function isAuthenticated(): boolean {
  return !!getToken()
}
